import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { expanded: Boolean }

  connect() {
    this.expandedValue = false
    // Close dropdown when clicking outside
    document.addEventListener("click", (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    })
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.expandedValue = !this.expandedValue
    this.updateView()
  }

  updateView() {
    if (this.expandedValue) {
      this.menuTarget.classList.remove("hidden")
    } else {
      this.menuTarget.classList.add("hidden")
    }
  }

  close() {
    this.expandedValue = false
    this.updateView()
  }
}

